<template>
    <div class="winfoengine risk-factor-page">
        <div class="filter-section">
            <div class="row">
                <div class="col-md-9">
                    <h2>SDK Configuration</h2>
                </div>
                <!-- <div class="col-md-3 text-right">
                    <strong><em>Name Screening Last Updated At</em></strong> : {{$moment(lastUpdatedAt).format('MMM D, YYYY')}} <br/>
                    <strong><em>Categorisations Last Configured At</em></strong> : {{$moment(lastListUpdatedAt).format('MMM D, YYYY')}}
                </div> -->
            </div>
            <div class="row">
                <div class="col-md-9"></div>
                <div class="col-md-3 d-flex justify-content-end">
                    <b-button
                        :disabled="loading || fieldsToUpdate.length < 1"
                        variant="primary"
                        size="sm"
                        @click="updateList"
                        ><i style="font-size: 14px" class="icon-done"></i>
                        Update</b-button
                    >
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <b-button
                        :disabled="loading"
                        variant="primary"
                        size="sm"
                        @click="resetCompleteList"
                    >
                        Generate Config
                    </b-button>
                    <!--   
                     <i style="font-size: 14px" class="icon-loop"></i> 
                     -->
                </div>
            </div>
        </div>

        <!-- Tabs Start  -->
        <div class="mt-4">
            <base-table-spinner v-if="loading"></base-table-spinner>
            <b-tabs
                v-else
                v-model="tabIndex"
                active-nav-item-class="font-weight-bold"
                active-tab-class="bg-white p-4"
                content-class=""
            >
                <b-tab :title-link-class="tabLinkClass(1)">
                    <template #title>
                        <h5>Feature selection</h5>
                    </template>
                    <div>
                        <ScreningListTable
                            :add-field-to-update="addFieldToUpdate"
                            :data="specialInterestData"
                            :fields="[
                                'Feature',
                                'Description',
                                'Status',
                                'Price Per Unit',
                                'Action',
                            ]"
                        />
                    </div>
                </b-tab>
                <b-tab :title-link-class="tabLinkClass(0)">
                    <template #title>
                        <h5>ID Document selection</h5>
                    </template>
                    <div>
                        <ScreningListTable
                            :add-field-to-update="addFieldToUpdate"
                            :data="sanctionData"
                            :fields="[
                                'Country',
                                'Documents',
                                'Status',
                                'Action',
                            ]"
                        />
                    </div>
                </b-tab>

                <!-- <b-tab v-if="country == 'Pakistan'" :title-link-class="tabLinkClass(2)">
                        <template #title>
                            <h5>PEP</h5>
                        </template>
                        <div>
                            <ScreningListTable :addFieldToUpdate="addFieldToUpdate" :data="pepData" :fields="['PEP', 'Publisher', 'Status', 'Action']"/> 
                        </div>
                </b-tab>
                <b-tab :title-link-class="tabLinkClass(3)">
                        <template #title>
                            <h5>SMART SEARCH</h5>
                        </template>
                        <div>
                            <ScreningListTable :addFieldToUpdate="addFieldToUpdate" :data="smartSearchData" :fields="['SMART SEARCH', 'Publisher', 'Status', 'Action']"/> 
                        </div>
                </b-tab> -->
            </b-tabs>
        </div>
    </div>
</template>

<script>
import ScreningListTable from './IdvScreeningListTable.vue'
import resource from '@/api/resource'
import { mapGetters } from 'vuex'
import request from '../../../utils/request'
const listCustomizAPI = new resource('configurations/idv')
const generate = new resource('configurations/idvconfiguration/create')
//import file from '../../../../public/files/idenfo.IdvConfiguration.json'
const axios = require('axios')
const FormData = require('form-data')
const fs = require('fs')

export default {
    components: {
        ScreningListTable,
    },
    props: {
        ds: {
            type: [String],
            required: false,
        },
    }, // End of Component > props
    data() {
        return {
            tabIndex: 0,
            lastUpdatedAt: new Date(),
            lastListUpdatedAt: new Date(),
            list: [],
            fieldsToUpdate: [],
            country: process.env.VUE_APP_COUNTRY,
        }
    },
    computed: {
        ...mapGetters(['showPageLoader', 'loading', 'dataSegmentId']),
        sanctionData() {
            console.log('list', this.list)
            if (!this.list) return []
            return this.list.filter((el) => el.category == 'configuration')
        },

        specialInterestData() {
            if (!this.list) return []

            // Define the custom order for `value`
            const customOrder = [
                'doc_val',
                'Ocr',
                'ocrscreen',
                'liveness',
                'face',
                'createcustomer',
                'namescreening',
                'risk',
            ]
            // Iterate through the list, filter by category, and sort the nested `data` array
            console.log('this.list', this.list)
            return this.list
                .filter((el) => el.category === 'global_idv_config')
                .map((el) => {
                    const sortedData = el.data.sort((a, b) => {
                        const indexA = customOrder.indexOf(a.value)
                        const indexB = customOrder.indexOf(b.value)

                        // If a value is not in the customOrder array, assign it the lowest priority
                        const priorityA =
                            indexA === -1 ? customOrder.length : indexA
                        const priorityB =
                            indexB === -1 ? customOrder.length : indexB

                        return priorityA - priorityB
                    })

                    console.log('sortDta', sortedData)

                    // Return the sorted `data` while preserving the rest of the object
                    return { ...el, data: sortedData }
                })
        },

        pepData() {
            if (!this.list) return []
            return this.list.filter((el) => el.category == 'PEP')
        },
        smartSearchData() {
            if (!this.list) return []
            return this.list.filter((el) => el.category == 'Smart Search')
        },
    }, // End of Component > computed
    watch: {
        tabIndex(val) {
            console.log('tab', val)
        },
    },
    mounted() {
        console.log(
            'Received parameter:',
            this.ds ? this.ds : this.dataSegmentId
        )
        this.getListData()
    }, // End of Component > mounted

    methods: {
        tabLinkClass(index) {
            if (this.tabIndex === index) {
                return [
                    'font-weight-bold',
                    'text-dark',
                    'tabHeading',
                    'w-210',
                    'text-center',
                ]
            } else {
                return [
                    'bg-light',
                    'text-dark',
                    'tabHeading',
                    'w-210',
                    'text-center',
                ]
            }
        },
        async getListData() {
            this.$store.commit('setLoading', true)
            console.log('this', this.ds ? this.ds : this.dataSegmentId)
            try {
                let dataSegment = this.ds ? this.ds : this.dataSegmentId
                let { data } = await listCustomizAPI.list({
                    dataSegmentId: dataSegment,
                })
                if (!_.isEmpty(data.data)) {
                    this.list = data.data
                    this.lastUpdatedAt = this.$moment(
                        data.lastUpdateDate
                    ).subtract(1, 'days')
                    this.lastListUpdatedAt = this.$moment(
                        data.lastListUpdatedAte
                    )
                }
            } catch (e) {
                console.log('error:', e)
            }
            this.$store.commit('setLoading', false)

            // console.log(this.formData)
            // console.log('this.lastUpdatedAt',this.lastUpdatedAt)
        },
        async resetCompleteList() {
            this.$store.commit('setLoading', true)
            let data = new FormData()
            //    data.append('file', fs.createReadStream(file));
            const url = process.env.IDV_CONFIG_CREATE
                ? process.env.IDV_CONFIG_CREATE
                : `${process.env.VUE_APP_API_URL}configurations/idvconfiguration/create`
            console.log('url', url)
            console.log('ds', this.ds)

            data.append('dataSegmentId', this.ds)
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                // headers: {
                //     'Authorization': '••••••',
                //     ...data.getHeaders()
                // },
                data: data,
            }
            const responseaDta = await axios.request(config)
            if (responseaDta) {
                location.reload()
            }
        },
        async updateList() {
            this.$store.commit('setLoading', true)
            const response = await request.put(
                'configurations/idvconfiguration/updateMany',
                {
                    fields: this.fieldsToUpdate,
                }
            )
            if (response) {
                this.fieldsToUpdate = []
                this.$store.commit('setLoading', false)
            }
            //  location.reload()
        },
        // addFieldToUpdate(data) {
        //     console.log('test', this.list)
        //     if (data._id) {
        //         if (data.value == 'createcustomer') {
        //             this.list = this.list.map((el) => {
        //                 if (el.category == data.category) {
        //                     //   el.status = data.status;
        //                     el.data = el.data.map((subEl) => {
        //                         if (
        //                         //    subEl.value == 'namescreening' ||
        //                         //    subEl.value == 'risk' ||
        //                             subEl.value == 'Ocr' 
        //                             //||
        //                        //     subEl.value == 'doc_val'
        //                         )
        //                             subEl.status = data.status
        //                         let fields = [...this.fieldsToUpdate].filter(
        //                             (el) => el.value != ''
        //                         )
        //                         this.fieldsToUpdate = [...fields, { ...subEl }]
        //                         return subEl
        //                     })
        //                 }
        //                 return el
        //             })
        //         }
        //         if (data.value == 'Ocr') {
        //             this.list = this.list.map((el) => {
        //                 if (el.category == data.category) {
        //                     //   el.status = data.status;
        //                     el.data = el.data.map((subEl) => {
        //                         if (
        //                        //     subEl.value == 'ocrscreen'
        //                             // ||
        //                          //   subEl.value == 'namescreening' ||
        //                          //   subEl.value == 'risk' ||
        //                             subEl.value == 'doc_val'
        //                             // ||
        //                           //  subEl.value == 'createcustomer'
        //                         )
        //                             subEl.status = data.status
        //                         let fields = [...this.fieldsToUpdate].filter(
        //                             (el) => el.value != ''
        //                         )
        //                         this.fieldsToUpdate = [...fields, { ...subEl }]
        //                         return subEl
        //                     })
        //                 }
        //                 return el
        //             })
        //         }

        //         if (data.value == 'face') {
        //             this.list = this.list.map((el) => {
        //                 if (el.category == data.category) {
        //                     //   el.status = data.status;
        //                     el.data = el.data.map((subEl) => {
        //                         if (
        //                             subEl.value == 'liveness' ||
        //                             subEl.value == 'doc_val'
        //                         )
        //                             subEl.status = data.status
        //                         let fields = [...this.fieldsToUpdate].filter(
        //                             (el) => el.value != ''
        //                         )
        //                         this.fieldsToUpdate = [...fields, { ...subEl }]
        //                         return subEl
        //                     })
        //                 }
        //                 return el
        //             })
        //         }

        //         if (data.value == 'ocrscreen') {
        //             this.list = this.list.map((el) => {
        //                 if (el.category == data.category) {
        //                     //   el.status = data.status;
        //                     el.data = el.data.map((subEl) => {
        //                         if (subEl.value == 'Ocr')
        //                             subEl.status = data.status
        //                         let fields = [...this.fieldsToUpdate].filter(
        //                             (el) => el.value != ''
        //                         )
        //                         this.fieldsToUpdate = [...fields, { ...subEl }]
        //                         return subEl
        //                     })
        //                 }
        //                 return el
        //             })
        //         }

        //         // if (data.value == 'doc_val') {
        //         //     this.list = this.list.map((el) => {
        //         //         if (el.category == data.category) {
        //         //             //   el.status = data.status;
        //         //             el.data = el.data.map((subEl) => {
        //         //                 if (subEl.value == 'Ocr' || 
        //         //                      subEl.value == 'ocrscreen' 
        //         //                 )
        //         //                     subEl.status = data.status
        //         //                 let fields = [...this.fieldsToUpdate].filter(
        //         //                     (el) => el.value != ''
        //         //                 )
        //         //                 this.fieldsToUpdate = [...fields, { ...subEl }]
        //         //                 return subEl
        //         //             })
        //         //         }
        //         //         return el
        //         //     })
        //         // }

        //         let fields = [...this.fieldsToUpdate].filter(
        //             (el) => el._id != data._id
        //         )
        //         this.fieldsToUpdate = [...fields, { ...data }]

        //         this.addFieldToUpdate()
        //         return
        //     }

        //     // edit parent/ country
        //     this.list = this.list.map((el) => {
        //         if (
        //             el.category == data.category &&
        //             el.country == data.country
        //         ) {
        //             el.status = data.status
        //             el.data = el.data.map((subEl) => {
        //                 subEl.status = data.status
        //                 let fields = [...this.fieldsToUpdate].filter(
        //                     (el) => el._id != data._id
        //                 )
        //                 this.fieldsToUpdate = [...fields, { ...subEl }]
        //                 return subEl
        //             })
        //         }
        //         return el
        //     })
        // },

    addFieldToUpdate(data) {

    if (!data || !data.value) return;

    const dependencies = {
        "doc_val": { parent: [], child: ["Ocr", "ocrscreen","face", "createcustomer", "namescreening", "risk"] },
        "Ocr": { parent: ["doc_val"], child: ["ocrscreen", "createcustomer", "namescreening", "risk"] },
        "ocrscreen": { parent: ["Ocr"], child: [] },
        "liveness": { parent: [], child: ["face","createcustomer","namescreening", "risk"] },
        "face": { parent: ["liveness","doc_val"], child: ["createcustomer","namescreening", "risk"] },
        "createcustomer": { parent: ["Ocr","face"], child: ["namescreening", "risk"] },
        "namescreening": { parent: ["createcustomer","face"], child: [] },
        "risk": { parent: ["createcustomer","face"], child: [] },
        "AE":{parent:[],child:["uae_id_card_old","uae_id_card_new"]},
        "UK": {parent:[],child:["uk_driver","uk_brp","uk_passport"]},
        "QA": {parent:[],child:["qatar_id_card_old","qatar_id_card_new"]},
        "GL": {parent:[],child:["global_passport"]},
        "PK": {parent:[],child:["paksmart","Pak_Passport","pak_urdu"]},
    };

    // Helper function to check if all parents are enabled
    const areParentsEnabled = (field) => {
        if(dependencies[field]){
            return dependencies[field].parent.every((parent) =>
            this.list.some((el) =>
                el.data.some((subEl) => subEl.value === parent && subEl.status)
            )
        );
        }
       return true
    };

    // Function to enable/disable a field
    const updateFieldStatus = (field, status) => {
        this.list = this.list.map((el) => {
            el.data = el.data.map((subEl) => {
                if (subEl.value === field) {
                    subEl.status = status;
                    if(( el.category == 'configuration' && dependencies[el.country] && dependencies[el.country].child.includes(field) && data.data && !status) || !areParentsEnabled(field)){
                        subEl.disabled = true
                    }else{
                        subEl.disabled = false
                    }
                }
                return subEl;
            });
            return el;
        })
    };
    const updateChildren = (field,status) => {
          if(dependencies[field]){
                dependencies[field].child.forEach((child) => {
                    if(areParentsEnabled(child) || !status){
                        updateFieldStatus(child, status);
                    }
                });
          }
        };
    if (data.status) {
        // **Prevent enabling if parent is not enabled**
      
            updateFieldStatus(data.value, true);
            if(data.data || data.category !=  'configuration'){
                updateChildren(data.value,true)
            }
    } else {
        // **Disable the selected field and all its children**        

        updateFieldStatus(data.value, false);
        if(data.data || data.category !=  'configuration'){
            updateChildren(data.value,false);
        }
    }

    // Update fieldsToUpdate list
    let fields = this.list.filter(el => el.category == data.category );
    this.fieldsToUpdate = [...this.fieldsToUpdate , ...(fields.map(el=> el.data).flat())]
}





    },

}
</script>

<style>
* {
    /* font-family: Montserrat; */
}
p {
    font-size: 14px;
}
.tabHeading {
    text-decoration: none !important;
    font-size: 15px !important;
    padding-top: 12px;
}
.badge-light {
    background-color: lightgray;
}
.badge-success {
    background-color: #8dcd83;
    color: white;
}

.value {
    font-weight: 600;
    display: inline-block;
}

.field,
.field .label {
    padding-bottom: 10px;
}

.icon-status {
    width: 24px;
    height: 24px;
    border-radius: 100%;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    top: -5px;
}
span.icon-status i {
    color: #fff;
    font-size: 12px;
}
span.icon-status.success {
    background-color: #00c535;
}

span.icon-status.danger {
    background-color: #c91f37;
}

.badge-pill {
    font-size: 14px;
    padding: 4px 12px;
}

.pdf-icon-custom div {
    width: 26px;
    display: inline-block;
    margin-left: 10px;
}

.border-bottom-2 {
    border-bottom-width: 2px !important;
}

.custom-pill-format {
    display: block;
    width: fit-content;
    margin-bottom: 3px;
}
.border-bottom-custom-1 {
    border-bottom: #695b5b 2px solid;
}
.customers-info-section {
    min-height: 254px;
}
.w-210 {
    min-width: 210px;
    width: fit-content;
}
.form-details .col-md-4,
.form-details .col-md-5,
.form-details .col-md-6,
.form-details .col-md-12 {
    padding-left: 0px;
}

.customers-info-section ul li {
    list-style-type: none;
}

.customer-info img {
    min-width: 60%;
    margin-left: auto;
    margin-right: auto;
}
.sticky-customer-card {
    top: 52px;
    position: sticky;
    background: white;
    z-index: 1;
    border-bottom: 1px rgba(99, 99, 99, 0.2);
    border-radius: 0px !important;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
</style>
